import { useCustomSuspenseQuery } from "@/hooks/use-graphql-client";

import type * as QueryRepository from "@/components/features/settings/payment-credit/repository/query";

import { PAYMENT_CREDIT_QUERY } from "./schema";

export const usePaymentCreditQuery = (hotelID: string) => {
	const { data } = useCustomSuspenseQuery(PAYMENT_CREDIT_QUERY, { variables: { hotelID } });

	return {
		paymentCredit: data?.paymentCredit ?? undefined,
		hotel: {
			email: data?.hotel.email ?? "",
		},
		receiptSetting: data?.receiptSetting ?? undefined,
	} satisfies QueryRepository.ServerModel;
};

usePaymentCreditQuery.displayName = "usePaymentCreditQuery";
